import { Box, Container, Grid } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Card, Typography } from '@nutrien/cxp-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';

import { useMst } from '../../mobx-models/Root';
import { useFileStorage } from '../../utilities';
import { IMAGE_PATH } from '../../utilities/constants';
import LoadingLeaf from '../LoadingLeaf';
import LoginFlow from '../LoginFlow';
import ResetPassword from '../ResetPassword';
import useStyles from './Login.styles';

const Login: React.FC = () => {
  const classes = useStyles();
  const { clearAttachmentStore } = useFileStorage();
  const showForceResetPassword = false;
  const cognitoUser = true;
  const [isLoading, setIsLoading] = useState(true);
  const { configCatFlag } = useMst();

  useEffect(() => {
    clearAttachmentStore();
  }, []);

  return (
    <>
      {isLoading && (
        <div className={classes.loading}>
          <LoadingLeaf />
        </div>
      )}

      {!showForceResetPassword && (
        <Grid container justifyContent="center" alignItems="center" item md={12}>
          <Box className={classes.box}>
            <Card smoothShadow>
              <Container className={classes.container} id="responsive" maxWidth="xs">
                {!isLoading && (
                  <img className={classes.nutrien_logo} src={`${IMAGE_PATH}/nutrien_dark.svg`} />
                )}
                <Typography className="aims_name" variant="h5">
                  AIMS - INSPECTION APP
                </Typography>

                <LoginFlow isLoading={isLoading} setIsLoading={setIsLoading} />
                {configCatFlag?.blueBanner?.display === true && (
                  <Alert severity="info">{configCatFlag?.blueBanner?.message}</Alert>
                )}
                {configCatFlag.redBanner?.display === true && (
                  <Alert severity="error">{configCatFlag?.redBanner?.message}</Alert>
                )}
              </Container>
            </Card>
          </Box>
        </Grid>
      )}

      {showForceResetPassword && <ResetPassword user={cognitoUser} />}
    </>
  );
};

export default observer(Login);
